<template>
	<div id="not-found">
		<div class="container">
            <static-image hash="pagina-no-encontrada"></static-image>
			<h1 class="mb-2 page-title"> {{ 'pagina-no-encontrada' | static-title }}</h1>
			<static-markdown class="mt-5" :content="'pagina-no-encontrada' | static-content"></static-markdown>
		</div>
	</div>
</template>

<script>
export default {
    name: 'not-found',
}
</script>


<style lang="scss">

@import '../../../sass/utils/variables';

#not-found {
    height: calc(100vh - 20em);
    display: flex;
    align-items: center;
    .container {
        max-width: 800px;
        margin: 0 auto;
        padding: 40px 20px;
        text-align: center;

        .static-markdown {
            max-width: 400px;
            display: inline-block;
        }

        .static-image {
            img {
                width: 100%;
                max-width: 240px;
                height: auto;
            }
            margin-bottom: 30px;
        }
        
        h1, h2 {
            font-size: 1.5rem;
            color: $brand-danger;
            &.page-title {
                font-size: 2rem;
                text-transform: uppercase;
            }
        }
        a {
            color: $primary;
        }
    }
}
</style>